<div class="container mt-5 pt-5 " style="margin-bottom: 15rem !important">
  <div class="row">
    <div class="col-sm-2"></div>

    <div class="col-sm-8 " style="margin-bottom: 300px; margin-top: 150px;">
      <div style="text-align: justify">
        <h1 class="text-center">Políticas de privacidad</h1>
        <p></p>
        <p></p>
        <br>
        <p>
          Archivo Histórico del Diario Oficial El Peruano, persona jurídica de derecho
          privado describe, a través de este documento, las normas de uso del
          sitio catalogodigital.elperuano.pe y de cualquier otro sitio web,
          tienda o aplicación operada por el titular.
        </p>
        <p>
          Al continuar navegando por este sitio web, usted está aceptando estar
          de acuerdo con las condiciones de uso que figuran a continuación.
        </p>
        <p>
          Si no está de acuerdo con los términos de este acuerdo, le pedimos que
          no haga ningún otro uso de este sitio web, mucho menos que registrar o
          enviar sus datos personales.
        </p>
        <p>
          Las condiciones de uso publicadas pueden ser modificadas o
          actualizadas en cualquier momento, la cual además de estar publicada
          en la web, y en caso exista un cambio significativo podemos informarle
          utilizando la información de contacto que tenemos en nuestra base de
          datos o mediante una notificación.
        </p>
        <p>
          El uso de este sitio web después de los cambios significa que usted
          acepta las condiciones de uso revisadas. Si, después de leer la
          versión revisada, no está de acuerdo con sus términos, por favor,
          termine su acceso.
        </p>
        <p>
          <strong>Sección 1 – Usuario</strong><br />
          El uso de este sitio web le otorga automáticamente la condición de
          Usuario e implica su plena aceptación de todas las directrices y
          condiciones incluidas en estas Condiciones.
        </p>
        <p>
          <strong
            >Sección 2 – Adhesión junto con la política de privacidad</strong
          ><br />
          El uso de este sitio web implica la adhesión a estas Condiciones de
          Uso y a la versión más actualizada de la Política de Privacidad de
          Archivo Histórico del Diario Oficial El Peruano.
        </p>
        <p>
          <strong>Sección 3 – Condiciones de acceso</strong><br />
          En general, el acceso al sitio web de Archivo Histórico del Diario Oficial El Peruano
          es gratuito y no requiere registro previo.
        </p>
        <p>
          Sin embargo, para hacer uso de algunas funcionalidades, el usuario
          necesitará registrarse, creando una cuenta de usuario con un nombre de
          usuario y una contraseña de acceso.
        </p>
        <p>
          Es responsabilidad del usuario proporcionar únicamente información
          correcta, auténtica, válida, completa y actualizada, así como no
          revelar su nombre de usuario y contraseña a terceros.
        </p>
        <p>
          El sitio web ofrece al usuario la opción de publicar comentarios por
          el usuario, por lo que el Archivo Histórico del Diario Oficial El Peruano no consiente
          comentarios con contenidos de carácter discriminatorio, ofensivo o
          ilícito, o que infrinjan los derechos de autor o cualquier otro
          derecho de terceros.
        </p>
        <p>
          La publicación de cualquier comentario por parte del usuario de este
          sitio web, implica una licencia no exclusiva, irrevocable e
          irreversible para su uso, reproducción y publicación por parte de
          Archivo Histórico del Diario Oficial El Peruano en su sitio web, plataformas de
          internet y aplicaciones, o incluso en otras plataformas, sin ninguna
          restricción o limitación.
        </p>
        <p>
          <strong>Sección 4 – Cookies</strong><br />
          La información sobre el uso que usted hace de este sitio web puede
          recogerse a través de las cookies. Las cookies son piezas de
          información que se almacenan directamente en el equipo que está
          utilizando. Las cookies permiten recoger información como el tipo de
          navegador, el tiempo de permanencia en el sitio web, las páginas
          visitadas, las preferencias de idioma y otros datos de tráfico
          anónimos. Nosotros y nuestros proveedores de servicios utilizamos la
          información para la protección de la seguridad, para facilitar la
          navegación, mostrar la información de manera más eficiente y
          personalizar su experiencia al utilizar este sitio web, así como para
          el seguimiento en línea. También recopilamos información estadística
          sobre el uso del sitio web para mejorar continuamente nuestro diseño y
          funcionalidad, para entender cómo se utiliza el sitio web y para
          ayudarle a resolver problemas relevantes.
        </p>
        <p>
          Si no desea que se recoja su información a través de las cookies,
          existe un procedimiento sencillo en la mayoría de los navegadores que
          permite rechazar automáticamente las cookies, o le da la opción de
          aceptar o rechazar la transferencia de una cookie específica (o
          varias) de un sitio web concreto a su ordenador. Sin embargo, esto
          puede crear inconvenientes en su uso del sitio web.
        </p>
        <p>
          La configuración que elija puede afectar a su experiencia de
          navegación y al funcionamiento que requiere el uso de cookies. En este
          sentido, rechazamos cualquier responsabilidad por las consecuencias
          derivadas del funcionamiento limitado de este sitio web causado por la
          desactivación de las cookies en su dispositivo (incapacidad para
          establecer o leer una cookie).
        </p>
        <p>
          <strong>Sección 5 – Propiedad intelectual</strong><br />
          Todos los elementos de Archivo Histórico del Diario Oficial El Peruano son propiedad
          intelectual de la misma o de sus licenciantes. Estos términos o el uso
          del sitio web no le otorgan ninguna licencia o derecho de uso de los
          derechos de propiedad intelectual de Archivo Histórico del Diario Oficial El Peruano o
          de cualquier tercero.
        </p>
        <p>
          <strong>Sección 6 – Enlaces a sitios web de terceros</strong><br />
          Este sitio web puede contener, de vez en cuando, enlaces de hipertexto
          que le redirigirán a sitios web de nuestros socios, anunciantes,
          proveedores, etc. Si hace click en uno de estos enlaces a cualquiera
          de estos sitios, recuerde que cada sitio tiene sus propias prácticas
          de privacidad y que el Archivo Histórico del Diario Oficial El Peruano no son
          responsables de esas políticas. Por favor, consulte esas políticas
          antes de enviar cualquier dato personal a esos sitios.
        </p>
        <p>
          El Archivo Histórico del Diario Oficial El Peruano no es responsable de las políticas
          y prácticas de recopilación, uso y divulgación (incluidas las
          prácticas de protección de datos) de otras organizaciones, como
          Facebook, Apple, Google, Microsoft, o cualquier otro desarrollador de
          software o proveedor de aplicaciones, tienda de medios sociales,
          sistema operativo, proveedor de servicios de internet o fabricante de
          dispositivos, incluidos los Datos Personales que usted divulgue a
          otras organizaciones a través de las aplicaciones, en relación con
          dichas aplicaciones, o publicados en nuestras redes sociales. Le
          recomendamos que se informe sobre la política de privacidad y las
          condiciones de uso de cada sitio web visitado o proveedor de servicios
          utilizado.
        </p>
        <p>
          <strong>Sección 7 – Plazos y modificaciones</strong><br />
          El funcionamiento de este sitio web es por tiempo indefinido.
        </p>
        <p>
          La totalidad del sitio web o cada una de sus secciones podrá ser
          cerrada, suspendida o interrumpida unilateralmente por Archivo Histórico
          del Diario Oficial El Peruano, en cualquier momento y sin previo aviso.
        </p>
        <p>
          <strong>Sección 8 – Datos personales</strong><br />
          Durante el uso de este sitio web, ciertos datos personales serán
          recogidos y procesados por Archivo Histórico del Diario Oficial El Peruano y/o los
          Socios. Las normas relativas al tratamiento de los datos personales de
          Archivo Histórico del Diario Oficial El Peruano están estipuladas en la Política de
          Privacidad.
        </p>
        <p>
          <strong>Sección 9 – Contacto</strong><br />
          Para sugerencias y/o comentarios sobre los términos y condiciones de
          uso de nuestro sitio Web puede contactarnos al correo electrónico:
          catalogodigital@editoraperu.com.pe.
        </p>
      </div>

      <div class="col-sm-2"></div>
    </div>
  </div>
</div>
